import Paper from '@material-ui/core/Paper'
import React from 'react'

export default function QuoteSummary() {
  return (
    <Paper>

    </Paper>
  )
}



// WEBPACK FOOTER //
// ./src/views/Orders/QuoteSummary.jsx